import React from "react";
import styled from "styled-components/macro";
import Button, { SecondaryButton } from "./Button";
import { mediaQueries } from "../styles/media.js";

const JunoAction = styled.div`
  margin-top: var(--juno-space-7);
  margin-bottom: var(--juno-space-4);

  ${mediaQueries.md} {
    margin-top: var(--juno-space-8);
    margin-bottom: var(--juno-space-4);
  }
`;

const SecondaryAction = styled.a`
  font-size: var(--juno-font-size-body-sm);
  line-height: normal;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }
  margin-bottom: 0.25em;
  color: var(--juno-color-link);
  cursor: pointer;

  &:hover {
    color: var(--juno-color-link-hover);
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }
`;

function Action(props) {
  return (
    <JunoAction>
      {props.secondaryAction ? <SecondaryAction {...props}>{props.children}</SecondaryAction> : null}
      {props.secondaryButton ? <SecondaryButton {...props}>{props.children}</SecondaryButton> : null}
      {!props.secondaryAction && !props.secondaryButton ? <Button {...props}>{props.children}</Button> : null}
    </JunoAction>
  );
}

export default Action;
